import yup from 'yup'

export function getValidationSchema (staticData) {
  const { BUSINESS } = staticData.CONST.PAYMENT_SERVICE_TYPES
  const {
    DIRECT_TRANSFER,
    DONATION_OTHER,
    PAYPAL
  } = staticData.CONST.PAYMENT_TRANSFER_METHODS
  const { COUNTRIES } = staticData.CONST
  const countriesWithRequiredAddress = [
    COUNTRIES.BANGLADESH,
    COUNTRIES.BRAZIL,
    COUNTRIES.CAMEROON,
    COUNTRIES.COLOMBIA,
    COUNTRIES.JORDAN,
    COUNTRIES.KENYA,
    COUNTRIES.PAKISTAN,
    COUNTRIES.ZIMBABWE
  ]

  function isDirectTransferOrDonationOther (paymentTransferMethodId) {
    return (
      paymentTransferMethodId === DIRECT_TRANSFER ||
      paymentTransferMethodId === DONATION_OTHER
    )
  }

  return yup.object().shape({
    paymentServiceTypeId: yup
      .number()
      .required('Payment service type field is required')
      .typeError('Payment service type field is required'),
    companyName: yup.mixed().when('paymentServiceTypeId', {
      is: BUSINESS,
      then: yup.string().required('Company name field is required')
    }),
    vatNumber: yup.mixed().when('paymentServiceTypeId', {
      is: BUSINESS,
      then: yup.string().required('VAT number field is required')
    }),
    expert: yup.object().shape({
      address: yup.object().shape({
        address1: yup
          .string()
          .nullable()
          .required('Address is required'),
        city: yup
          .string()
          .nullable()
          .required('City is required'),
        postalCode: yup
          .string()
          .nullable()
          .required('Postal code is required'),
        state: yup.string().nullable(),
        countryId: yup
          .number()
          .integer()
          .nullable()
          .required('Country is required')
      })
    }),
    paymentTransferMethodId: yup
      .number()
      .required('Payment transfer method field is required')
      .typeError('Payment transfer method field is required'),
    accountOwner: yup.mixed().when('paymentTransferMethodId', {
      is: isDirectTransferOrDonationOther,
      then: yup.string().required('Account owner field is required'),
    }),
    accountNumber: yup.mixed().when('paymentTransferMethodId', {
      is: isDirectTransferOrDonationOther,
      then: yup
        .string()
        .required('Account number/IBAN field is required')
        .matches(
          /^\S+$/,
          'Only alphanumeric characters allowed, please do not add any spaces'
        )
    }),
    bankCode: yup.mixed().when('paymentTransferMethodId', {
      is: isDirectTransferOrDonationOther,
      then: yup.string().required('SWIFT CODE/ROUTING NUMBER field is required')
    }),
    bankName: yup.mixed().when('paymentTransferMethodId', {
      is: isDirectTransferOrDonationOther,
      then: yup.string().required('Bank name field is required')
    }),
    bankAddress: yup.object().when('paymentTransferMethodId', {
      is: isDirectTransferOrDonationOther,
      then: yup.object().shape({
        address1: yup.string().when('countryId', {
          is: countryId => countriesWithRequiredAddress.includes(countryId),
          then: yup
            .string()
            .nullable()
            .required('Address is required'),
          otherwise: yup.string().nullable()
        }),
        city: yup.string().when('countryId', {
          is: countryId => countriesWithRequiredAddress.includes(countryId),
          then: yup
            .string()
            .nullable()
            .required('City is required'),
          otherwise: yup.string().nullable()
        }),
        postalCode: yup.string().when('countryId', {
          is: countryId => countriesWithRequiredAddress.includes(countryId),
          then: yup
            .string()
            .nullable()
            .required('Postal code is required'),
          otherwise: yup.string().nullable()
        }),
        state: yup.string().nullable(),
        countryId: yup
          .number()
          .integer()
          .nullable()
          .required('Country is required')
      })
    }),
    payPalEmail: yup.mixed().when('paymentTransferMethodId', {
      is: PAYPAL,
      then: yup
        .string()
        .email('Email format is invalid')
        .required('PayPal email field is required')
        .typeError('PayPal email field is required')
    })
  })
}
